export default function AboutHeroSection() {
  return (
    <section className="relative bg-gradient-to-br from-green-50 to-blue-50 py-20 lg:py-32 overflow-hidden">
      {/* 背景画像 */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/c03bc8fd979867751f1b6c6b8bb0b61d.webp"
          alt="田園風景"
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/25 to-white/5"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl">
          <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            スマート農業で<br />
            <span className="text-[#2A6041]">未来を変える</span>
          </h1>
          
          <p className="text-xl lg:text-2xl text-gray-700 mb-8 font-medium">
            地域農業の発展と次世代への架け橋として
          </p>
          
          <p className="text-lg text-gray-600 leading-relaxed max-w-3xl">
            私たちIDS教習所グループは、最先端のスマート農業機器で地域農業の発展を支援し、農業に新しい可能性を創造します。
          </p>
        </div>
      </div>
    </section>
  );
}